/**
 * format · 纯展示格式化工具（shared 层，无 IO、无状态）
 */

/** 联系时间格式化（几分钟前 / 小时前 / 昨天 / N 天前） */
export function fmtAgo(min: number): string {
  if (min < 60) return `${min} 分钟前`
  if (min < 1440) return `${Math.floor(min / 60)} 小时前`
  const d = Math.floor(min / 1440)
  return d === 1 ? '昨天' : `${d} 天前`
}

/**
 * 会话时间标签：刚刚 / N分钟前 / N小时前 / N天前 / 月日
 * 7 天以内用相对时间，更早显示具体日期；跨年带年份。
 */
export function fmtSessionTime(ms: number, now = Date.now()): string {
  const diff = Math.max(0, now - ms)
  const min = Math.floor(diff / 60000)
  if (min < 1) return '刚刚'
  if (min < 60) return `${min}分钟前`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr}小时前`
  const day = Math.floor(hr / 24)
  if (day <= 7) return `${day}天前`
  const d = new Date(ms)
  const sameYear = d.getFullYear() === new Date(now).getFullYear()
  const md = `${d.getMonth() + 1}月${d.getDate()}日`
  return sameYear ? md : `${d.getFullYear()}年${md}`
}

const AV_COLORS = ['#a12dbe', '#be6c2d', '#be2d5d', '#2d8ebe', '#3b6d11', '#be582d', '#2d58be', '#5f5e5a']
/** 按名字哈希取头像底色（同人同色） */
export function avatarColor(name: string): string {
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0
  return AV_COLORS[h % AV_COLORS.length]
}
